import {
  ModalBodyProps as CModalBodyProps,
  ModalFooterProps as CModalFooterProps,
  ModalHeaderProps as CModalHeaderProps,
  Modal as ChakraModal,
  ModalProps as ChakraModalProps,
  CloseButtonProps,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalOverlayProps,
} from '@chakra-ui/react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { emptyFn } from '@waitroom/react-query';
import { ReactElement, ReactNode } from 'react';
import { Icon } from '../Icon/Icon';

export const inlineCloseProps = {
  position: 'relative',
  ml: 'auto',
  top: '0',
  right: '0',
};

export const closeProps = {
  top: '3',
  right: '4',
};

export interface ModalHeaderProps extends CModalHeaderProps {
  closeButton?: boolean;
  closeButtonProps?: Partial<CloseButtonProps>;
  inlineCloseButton?: boolean;
  children?: ReactNode;
}

const Header = ({
  inlineCloseButton,
  closeButton = true,
  closeButtonProps,
  children,
  ...rest
}: ModalHeaderProps): ReactElement | null => (
  <ModalHeader
    display="flex"
    lineHeight="short"
    pr={closeButton ? (inlineCloseButton ? '1' : '7') : '0'}
    pb={children ? '4' : '0'}
    {...rest}
  >
    {children}
    {closeButton ? (
      <ModalCloseButton
        {...(inlineCloseButton ? inlineCloseProps : closeProps)}
        {...closeButtonProps}
      >
        <Icon icon={faTimes} fontSize="lg" />
      </ModalCloseButton>
    ) : null}
  </ModalHeader>
);

const Body = (props: CModalBodyProps): ReactElement | null => <ModalBody {...props} />;
const Footer = (props: CModalFooterProps): ReactElement | null => <ModalFooter {...props} />;

export interface ModalProps extends Partial<ChakraModalProps> {
  children?: ReactNode;
  contentProps?: ModalContentProps;
  overlayProps?: ModalOverlayProps;
  forceCenter?: boolean;
}

const Modal = ({
  children,
  contentProps,
  overlayProps,
  isOpen = false,
  onClose,
  forceCenter,
  ...rest
}: ModalProps): ReactElement | null => (
  <ChakraModal {...rest} isOpen={isOpen} onClose={onClose ?? emptyFn}>
    <ModalOverlay
      {...overlayProps}
      zIndex="modal"
      className={`${overlayProps?.className || ''}${forceCenter ? 'center' : ''}`}
    >
      <ModalContent {...contentProps}>{children}</ModalContent>
    </ModalOverlay>
  </ChakraModal>
);

Modal.Header = Header;
Modal.Body = Body;
Modal.Footer = Footer;
export default Modal;
